import axios from "axios";
import { Img } from "components";
import FormWrapper from "components/FormWrapper";
import SocialHubCard from "components/NewCards/SocialHubCard";
import { error } from "components/Notify";
import ResetAndSubmit from "components/ResetAndSubmit";
import { ErrorMessageFunction } from "constants/static";
import { Formik, Form, FieldArray } from "formik";
import { useEffect, useState } from "react";
import { throttle } from 'lodash';
import { useRef } from 'react';
import { API_CONSTANT_ONBOARDING } from "utils";



const SOCIAL_HUB = [
    { icon: "/images/facebook.svg", status: "", description: "Don’t have a Facebook Business Page? (Click here):['https://www.facebook.com/pages/create'] to create.", name: "Facebook", id: 'fb' },
    { icon: "/images/instagram.svg", status: "", description: "Didn’t have instagram account? (Click here):['https://www.instagram.com/accounts/emailsignup'] to create", name: "Instagram", id: 'ig' },
    { icon: "/images/youtube.svg", status: "", description: "Didn’t have youtube channel? (Click here):['https://www.youtube.com/create_channel'] to create", name: "Youtube", id: 'yt' },
    { icon: "/images/googleBussniess.png", status: "", description: "Didn’t have business account? (Click here):['https://business.google.com/in/business-profile'] to create", name: "Google Business", id: 'gb' },
    { icon: "/images/linkdin.svg", status: "", description: "Didn’t have linkdin account? (Click here):['#'] to create", name: "LinkedIn", id: 'li' },
    { icon: "/images/yelp.svg", status: "", description: "Didn’t have yelp account? (Click here):['#'] to create", name: "Yelp", id: 'ylp' },
];

interface Props {
    handleNavigate?: any;
    resetFormData?: any;
    disableForm?: any;
}

const LinkYourAccounts = ({ handleNavigate, resetFormData, disableForm }: Props) => {

    const [linkYourAccountsState, setLinkYourAccountsState] = useState(null);
    const [loader, setLoader] = useState(false);
    const instituteData = JSON.parse(sessionStorage?.getItem('_DATA_') || '{}') || {};
    const hasHandled = useRef<{ [key: string]: boolean }>({});

    const loadInitialData = () => {
        const savedData = JSON.parse(sessionStorage.getItem("linkYourAccountSH")) || [];
        return savedData.length ? savedData : SOCIAL_HUB;
    };

    const handleGoogleSelection = async (google, setFieldValue, index, name) => {
        const LIST = loadInitialData();
        const googleObj = linkYourAccountsState?.[name];
        const instituteData = await JSON.parse(sessionStorage?.getItem('_DATA_') || '{}') || {};
        try {
            setLoader(loader => true);
            const headers = {
                'branch-id': instituteData?.BRANCH_ID || 1,
                'database': instituteData?.DATABASE_NAME,
                'institute-id': instituteData?.INSTITUTE_ID,
                'academic-year-id': instituteData?.ACADEMIC_YEAR_ID || 1,
                // Add other headers if needed
            };
            console.log("headers ",headers)
            console.log("instituteData ",instituteData)
            const response = await axios.post(`${API_CONSTANT_ONBOARDING}/comm/google/update_info`, {
                "BRANCH_ID": instituteData?.BRANCH_ID || 1,
                "ACCESS_TOKEN": googleObj?.data?.access_token,
                "REFRESH_TOKEN": googleObj?.data?.refresh_token,
                "PREFERRED_ID": google?.id || google?.name,
                "SERVICE": googleObj?.payload?.DATA?.SERVICE
            }, { headers });
            if (["fb", "ig"]?.includes(LIST?.[index]?.id)) {
                sessionStorage.setItem("linkYourAccountSH", JSON.stringify(
                    LIST?.map((item) => {
                        if (item?.status === "CONNECTED")
                            return item;
                        else
                            return ({
                                ...item,
                                selected_institute: {
                                    "BRANCH_ID": instituteData?.BRANCH_ID || 1,
                                    "ACCESS_TOKEN": googleObj?.data?.access_token,
                                    "REFRESH_TOKEN": googleObj?.data?.refresh_token,
                                    "PREFERRED_ID": google?.id || google?.name,
                                    "SERVICE": googleObj?.payload?.DATA?.SERVICE
                                },
                                status: ["fb", "ig"]?.includes(item?.id) ? "CONNECTED" : ""
                            })
                    })
                ));
            } else {
                sessionStorage.setItem("linkYourAccountSH", JSON.stringify(
                    LIST?.map((item, elementIndex) => {
                        if (item?.status === "CONNECTED")
                            return item;
                        else
                            return ({
                                ...item,
                                selected_institute: {
                                    "BRANCH_ID": instituteData?.BRANCH_ID || 1,
                                    "ACCESS_TOKEN": googleObj?.data?.access_token,
                                    "REFRESH_TOKEN": googleObj?.data?.refresh_token,
                                    "PREFERRED_ID": google?.id || google?.name,
                                    "SERVICE": googleObj?.payload?.DATA?.SERVICE
                                },
                                status: +elementIndex === +index ? "CONNECTED" : ""
                            })
                    })
                ));
            }
        } catch (error: any) {
            const errorDetails = error?.response?.message || error?.message;
            error(errorDetails, true);
        } finally {
            setLinkYourAccountsState(linkYourAccountsState => null);
            setLoader(loader => false);
        }
    }

    const handleInstituteSelection = async (schoolDetails, setFieldValue, index, name) => {
        const LIST = loadInitialData();
        const instituteData = JSON.parse(sessionStorage?.getItem('_DATA_') || '{}') || {};
        try {
            setLoader(loader => true);
            const headers = {
                'branch-id': instituteData?.BRANCH_ID,
                'database': instituteData?.DATABASE_NAME,
                'institute-id': instituteData?.INSTITUTE_ID,
                'academic-year-id': instituteData?.ACADEMIC_YEAR_ID,
                // Add other headers if needed
            };
            console.log("instituteData ", instituteData);
            console.log("headers ", headers);
            await axios.post(`${API_CONSTANT_ONBOARDING}/comm/facebook/update_info`, {
                BRANCH_ID: instituteData?.BRANCH_ID || 1,
                ACCESS_TOKEN: schoolDetails?.access_token || linkYourAccountsState?.[name]?.payload?.ID,
                PAGE_ID: schoolDetails?.id || schoolDetails?.fb_page_id
            }, { headers });
            if (["fb", "ig"]?.includes(LIST?.[index]?.id)) {
                sessionStorage.setItem("linkYourAccountSH", JSON.stringify(
                    LIST?.map((item, elementIndex) => {
                        if (item?.status === "CONNECTED")
                            return item;
                        else
                            return ({
                                ...item,
                                selected_institute: {
                                    BRANCH_ID: instituteData?.BRANCH_ID || 1,
                                    ACCESS_TOKEN: schoolDetails?.access_token || linkYourAccountsState?.[name]?.payload?.ID,
                                    PAGE_ID: schoolDetails?.id || schoolDetails?.fb_page_id
                                },
                                status: ["fb", "ig"]?.includes(item?.id) ? "CONNECTED" : ""
                            })
                    })
                ));
            } else {
                sessionStorage.setItem("linkYourAccountSH", JSON.stringify(
                    LIST?.map((item, elementIndex) => {
                        if (item?.status === "CONNECTED")
                            return item;
                        else
                            return ({
                                ...item,
                                selected_institute: {
                                    BRANCH_ID: instituteData?.BRANCH_ID || 1,
                                    ACCESS_TOKEN: schoolDetails?.access_token || linkYourAccountsState?.[name]?.payload?.ID,
                                    PAGE_ID: schoolDetails?.id || schoolDetails?.fb_page_id
                                },
                                status: +elementIndex === +index ? "CONNECTED" : ""
                            })
                    })
                ));
            }
        } catch (error: any) {
            const errorDetails = error?.response?.message || error?.message;
            error(errorDetails, true);
        } finally {
            setLinkYourAccountsState(linkYourAccountsState => null);
            setLoader(loader => false);
        }
    }

    const handlePayload = async (payload, idName) => {
        try {
            setLoader(loader => true);

            let payloadURL = "";
            if (['facebook/pages']?.includes(payload?.URL)) {
                payloadURL = `${API_CONSTANT_ONBOARDING}/comm/${payload?.URL}?access_token=${payload?.ID}`
            } else if (['instagram/accounts']?.includes(payload?.URL)) {
                payloadURL = `${API_CONSTANT_ONBOARDING}/comm/${payload?.URL}?access_token=${payload?.ID}`
            } else if (['google/list?env=onboarding']?.includes(payload?.URL)) {
                payloadURL = `${API_CONSTANT_ONBOARDING}/comm/${payload?.URL}`
            }

            const headers = {
                'access-token': payload?.ID,
                'branch-id': instituteData?.BRANCH_ID || 1,
                'database': instituteData?.DATABASE_NAME,
            };


            const response: any = await (['facebook/pages', 'instagram/accounts']?.includes(payload?.URL) ?
                axios.get(payloadURL, { headers }) :
                (['google/list?env=onboarding']?.includes(payload?.URL) ? axios.post(payloadURL, payload?.DATA) : axios.get(payload))); // removed TABLE_DATA
            const data = response?.data?.data;

            if (![200, 201]?.includes(Number(response?.data?.code))) {
                if (['facebook/pages', 'instagram/accounts']?.includes(payload?.URL)) {
                    error(<a href="https://www.facebook.com/business/help/473994396650734?id=939256796236247" target="_blank">{response?.data?.message}</a>, true)
                }
            } else {
                if ((data?.list?.length || data?.length) === 0) {
                    let messageHolder = "";
                    if (payload?.DATA?.SERVICE === "gb") {
                        messageHolder = "Logged-in account has no associated business.";
                    } else if (payload?.DATA?.SERVICE === "yt") {
                        messageHolder = "Logged-in account has no associated channels.";
                    } else if (['facebook/pages', 'instagram/accounts']?.includes(payload?.URL)) {
                        messageHolder = "Logged-in account has no associated Pages.";
                    }
                    if (messageHolder) {
                        error(
                            ErrorMessageFunction({
                                externalURL: ['facebook/pages', 'instagram/accounts']?.includes(payload?.URL) ? "https://www.facebook.com/pages/creation" : "https://business.google.com/create",
                                customMessage: messageHolder,
                                name: ['facebook/pages', 'instagram/accounts']?.includes(payload?.URL) ? "Meta page" : "Google"
                            }),
                            true);
                    }
                }
                const listData = data[Object.keys(data).at(0)?.toString() as string] || [];
                setLinkYourAccountsState({
                    [idName]: { listData, data, payload }
                })
            }

        } catch (error) {
            console.log("error", error)
            const errorDetails = error?.response?.message || error?.message;
            error(errorDetails, true);
        } finally {
            setLoader(loader => false);
        }
    }

    useEffect(() => {
        const channel = new BroadcastChannel('popup_channel');

        const throttledHandlePayload = throttle((payload, name) => {
            const key = JSON.stringify(payload) + name;

            if (!hasHandled.current[key]) {
                hasHandled.current[key] = true;
                handlePayload(payload, name);
            }
        }, 2000);

        channel.onmessage = (event) => {
            if (event.data) {
                let payload: any = {};
                try {
                    payload = JSON.parse(event.data);
                } catch (err) { }

                let SSMedia: any = {};
                try {
                    SSMedia = JSON.parse(sessionStorage?.getItem('selectedSocialMedia') as any);
                } catch (err) { }

                if (SSMedia?.name === 'Instagram') {
                    payload = {
                        ...payload,
                        URL: 'instagram/accounts',
                    };
                } else if (['Google Business', 'Youtube'].includes(SSMedia?.name)) {
                    payload = {
                        ...payload,
                        DATA: {
                            ...payload.DATA,
                            SERVICE: SSMedia?.id,
                        },
                    };
                }

                const matchedName = SOCIAL_HUB?.find(
                    item => item?.name?.toLowerCase() === SSMedia?.name?.toLowerCase()
                )?.name;

                throttledHandlePayload(payload, matchedName);
            }
        };

        return () => {
            channel.close();
            throttledHandlePayload.cancel();
        };
    }, []);

    return (
        <FormWrapper
            title={"Revolutionize Your Institution’s Social Presence in Just 5 Minutes!"}
            titleLink="Why you need connect your institute socials?"
            description={<div className="w-full grid grid-cols-12 gap-4 my-2 sm:grid-cols-1 md:grid-cols-1">
                <div className="col-span-6 bg-linkYourAccountBlueGradient rounded-lg p-3 space-y-2 text-stone-50">
                    <p className="text-[2.3vh] font-medium tracking-wide">Streamlined Social Media Management</p>
                    <p className="text-[1.6vh] font-thin tracking-wide">Free up valuable time with AI-automated social media posting and engagement. Focus on what matters: educating and inspiring your students.</p>
                </div>
                <div className="col-span-6 bg-linkYourAccountBlueGradient rounded-lg p-3 space-y-2 text-stone-50">
                    <p className="text-[2.3vh] font-medium tracking-wide">Revenue Potential</p>
                    <p className="text-[1.6vh] font-thin tracking-wide">Transform your online presence into a money-making machine, with the potential to earn up to ₹2.5 crores.</p>
                </div>
            </div>}
            childern={<Formik
                initialValues={{ linkYourAccountSH: loadInitialData() }}
                enableReinitialize
                // validationSchema={validationSchema}
                onSubmit={(values) => {
                    sessionStorage.setItem("linkYourAccountSH", JSON.stringify(values.linkYourAccountSH));
                    handleNavigate()
                }}
            >
                {({ values, handleSubmit, resetForm, errors, setFieldValue }) =>
                    <FormWrapper
                        title={"Link your social Media accounts"}
                        description={"Sync your institution’s official social handles for real-time updates and boosted reach"}
                        customClass="mx-0"
                        childern={<Form onSubmit={handleSubmit}>
                            <div>
                                <div className="rounded-2xl my-1 mx-1">
                                    <FieldArray name="linkYourAccountSH">
                                        {({ push, remove }) => (
                                            <div className="grid grid-cols-4 gap-4 sm:grid-cols-1 md:grid-cols-1">
                                                {values.linkYourAccountSH.map((leaderElement, index) => (
                                                    <SocialHubCard
                                                        key={"asdakjsdhaskjdas" + index}
                                                        element={leaderElement}
                                                        listData={linkYourAccountsState?.[leaderElement?.name]}
                                                        handleGoogleSelection={google => handleGoogleSelection(google, setFieldValue, index, leaderElement?.name)}
                                                        handleInstituteSelection={institute => handleInstituteSelection(institute, setFieldValue, index, leaderElement?.name)}
                                                        loader={loader}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </FieldArray>
                                </div>
                            </div>
                            {(!disableForm && !loader) && <ResetAndSubmit
                                submitLabel="Proceed"
                                submitToolTip={!Boolean(values?.linkYourAccountSH?.filter(item => !!item?.status)?.length) && "At least one data is required for the next step."}
                                isError={!Boolean(values?.linkYourAccountSH?.filter(item => !!item?.status)?.length)}
                            // resetForm={() => {
                            //     resetForm();
                            //     resetFormData();
                            // }}
                            />}
                            {loader && <div className="flex justify-end items-center gap-4 mt-2 sm:justify-center">
                                <Img src={"/images/loader.gif"} className="w-10 h-10" />
                            </div>}
                        </Form>}
                    />}
            </Formik>}
        />
    );
}

export default LinkYourAccounts;